<template>
<section class="emotiosns">
    <div class="post-wrapper" v-for="(content,index) in contents" v-bind:key="index">
        <div class="post">
          <h3>{{ content.text }}</h3>
          <p class="post-description">{{content.description}}</p>
          by {{content.name}} | <a :href="'https://twitter.com/' + content.twitter" target="_blank">{{content.twitter}}</a><br><br>
          <span><a :href="'https://twitter.com/search?q=' + content.text + '&src=typed_query'" target="_blank">{{ content.text }}に関するツイート</a></span>
        </div>
    </div>
</section>    
</template>

<script>
  import {db} from '../plugins/firebase';

  export default {
    name: "emotions",
    data: () => ({
      contents: [],
      choiceActive : false
    }),

    firestore() {
      return {
        // firestoreのcommentsコレクションを参照
        contents: db.collection('emotions')

      }
    },
  }
</script>